import { TriangleAlert } from "lucide-react";

import { formatMeasurementValue } from "../../shared/measurements";
import { isOutOfRange, type ReadingVerdict } from "../../shared/pool-thresholds";

export type MeasurementValueView = {
  fieldKey: string;
  label: string;
  unit: string | null;
  value: number;
  verdict: ReadingVerdict;
};

/**
 * I valori di una misurazione, scritti come li leggerebbe una persona: `pH 7,4 · Cloro 1,2 ppm`.
 *
 * Sta in un componente solo perche compaiono in due posti, la checklist dell'intervento e la
 * scheda della struttura, e devono raccontare la stessa cosa allo stesso modo. Il fuori
 * intervallo si vede a colpo d'occhio ma non e un errore: e un valore da guardare.
 */
export function MeasurementValues({ values }: { values: MeasurementValueView[] }) {
  if (values.length === 0) return null;
  return (
    <span className="measurement-values">
      {values.map((valore) => {
        const fuori = isOutOfRange(valore.verdict);
        return (
          <span className={`measurement-value${fuori ? " measurement-value--fuori" : ""}`} key={valore.fieldKey}>
            <span className="measurement-value__label">{valore.label}</span>
            {formatMeasurementValue(valore.value, valore.unit)}
            {fuori && <TriangleAlert size={14} aria-label={`fuori intervallo, ${valore.verdict} il riferimento`} />}
          </span>
        );
      })}
    </span>
  );
}
